import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getCommunityOrganization } from '../js/common/api';

export const fetchCommunityOrganization = createAsyncThunk('community/org/fetch',
  (orgId) => getCommunityOrganization(orgId));

const slice = createSlice({
  name: 'brandInformation',
  initialState: {
    communityOrganization: null,
  },
  reducers: null,
  extraReducers: (builder) => {
    builder.addCase(fetchCommunityOrganization.fulfilled, (state, action) => {
      const { data: community } = action.payload || {};
      state.communityOrganization = {
        ...community,
        org: community.org ? {
          ...community.org,
          avatar: community.org.orgImageUrl,
        } : null,
      };
    });
  },
});

export const selectCommunityOrg = (state) => state.brandInformation.communityOrganization;

export default slice.reducer;
